import {Provider} from "react-redux";
import configureStore from "../configureStore";

export default function ProviderComponent ({ children } : { children: React.ReactNode }) {
  const store = configureStore();
  return (
    <Provider store={store}>
      {children}
    </Provider>
  );
}
